import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  howToGetLoyaltyDiscountHeader: {
    id: 'pd.loyalty.discount.how.to.header',
    defaultMessage: 'Kupujte oblíbené značky a kategorie se slevou',
  },
  registerStep: {
    id: 'pd.loyalty.discount.how.to.register',
    defaultMessage: 'Registrujte se',
  },
  newsletterStep: {
    id: 'pd.loyalty.discount.how.to.newsletter',
    defaultMessage: 'Odebírejte náš newsletter',
  },
  chooseBrandAndCategoryStep: {
    id: 'pd.loyalty.discount.how.to.choose.brand.category',
    defaultMessage: 'Vyberte si 3 značky a kategorii',
  },
  alreadyHaveAccount: {
    id: 'pd.loyalty.discount.how.to.already.have.account',
    defaultMessage: 'Již máte účet?',
  },
  logIn: {
    id: 'pd.loyalty.discount.how.to.log.in',
    defaultMessage: 'Přihlásit se',
  },
  registerNow: {
    id: 'pd.loyalty.discount.how.to.register.now',
    defaultMessage: 'Registrovat se',
  },
  setUpNow: {
    id: 'pd.loyalty.discount.how.to.set.up.now',
    defaultMessage: 'Nastavit',
  },
});
